// extracted by mini-css-extract-plugin
module.exports = {"divider_spacing":"styles_divider_spacing__2Lc0n"};